import { Routes } from '@angular/router';
import { adminGuard } from './core/services/admin.guard';
import { MAGAZINE_ROUTES } from './features/magazine/magazine.routes';

export const routes: Routes = [
  { path: '', pathMatch: 'full', redirectTo: 'landing' },
  {
    path: 'landing',
    loadChildren: () => import('./features/landing/landing.routes').then((m) => m.LANDING_ROUTES)
  },
  {
    path: 'home',
    loadChildren: () => import('./features/home/home.routes').then((m) => m.HOME_ROUTES)
  },
  {
    path: 'books',
    loadChildren: () => import('./features/books/books.routes').then((m) => m.BOOK_ROUTES)
  },
  {
    path: 'wishlist',
    loadChildren: () => import('./features/wishlist/wishlist.routes').then((m) => m.WISHLIST_ROUTES)
  },
  {
    // Eager — Magazine was feeling ~1s slow on first click due to lazy chunk + fade
    path: 'magazine',
    children: MAGAZINE_ROUTES
  },
  {
    path: 'authors',
    loadChildren: () => import('./features/authors/authors.routes').then((m) => m.AUTHOR_ROUTES)
  },
  {
    path: 'events',
    loadChildren: () => import('./features/events/events.routes').then((m) => m.EVENTS_ROUTES)
  },
  {
    path: 'details/:id',
    loadChildren: () => import('./features/details/details.routes').then((m) => m.DETAIL_ROUTES)
  },
  {
    path: '',
    loadChildren: () => import('./features/auth/auth.routes').then((m) => m.AUTH_ROUTES)
  },
  {
    path: 'profile',
    loadChildren: () => import('./features/profile/profile.routes').then((m) => m.PROFILE_ROUTES)
  },
  {
    path: 'orders',
    loadChildren: () => import('./features/orders/orders.routes').then((m) => m.ORDER_ROUTES)
  },
  {
    path: 'checkout',
    loadChildren: () => import('./features/checkout/checkout.routes').then((m) => m.CHECKOUT_ROUTES)
  },
  {
    path: 'admin',
    canActivate: [adminGuard],
    loadChildren: () => import('./features/admin/admin.routes').then((m) => m.ADMIN_ROUTES)
  },
  {
    path: '',
    loadChildren: () => import('./features/pages/pages.routes').then((m) => m.PAGES_ROUTES)
  },
  { path: '**', redirectTo: 'home' }
];
